export const AccountStatusProspect = 'P';